import { useEffect } from 'react'
import { loadYotpoScript } from '@/Util/Yotpo'
import { storyblokEditable } from '@storyblok/react'

export default ({ blok }) => {
    useEffect(() => {
        loadYotpoScript('https://cdn-widgetsrepository.yotpo.com/v1/loader/5zKoVjKhn7knikOUFsTxUyFjNGWWbOu6DeV11pe3');
    }, [])

    return (
        <div {...storyblokEditable(blok)}
            className={blok.class || "yotpo yotpo-pictures-widget"}
            data-gallery-id={blok.gallery_id}>
        </div>
    )
}
